(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-advance-contact]');
    sections.forEach(initSection);
  });

  function initSection(section) {
    var reasonStep = section.querySelector('[data-ac-reasons]');
    var formStep = section.querySelector('[data-ac-form-step]');
    var backButtons = section.querySelectorAll('[data-ac-back]');
    var reasonButtons = section.querySelectorAll('[data-ac-reason]');
    var forms = section.querySelectorAll('[data-ac-form]');

    reasonButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var reason = btn.getAttribute('data-ac-reason');

        // Highlight selected
        reasonButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        // Show form step
        reasonStep.classList.add('is-hidden');
        formStep.classList.add('is-active');

        // Show correct form
        forms.forEach(function (f) { f.classList.remove('is-active'); });
        var target = section.querySelector('[data-ac-form="' + reason + '"]');
        if (target) target.classList.add('is-active');
      });
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        formStep.classList.remove('is-active');
        reasonStep.classList.remove('is-hidden');
      });
    });
  }
})();
